// client/src/views/Interactive_parts/CoordPopup.js
import React from 'react';

export default function CoordPopup({ coord, onCopy, copied }) {
  if (!coord) return null;

  const x = Math.round(coord.x);
  const y = Math.round(coord.y);

  const handleCopyClick = (e) => {
    e.stopPropagation();
    if (onCopy) onCopy(coord);
  };

  const handleCloseClick = (e) => {
    e.stopPropagation();
    if (onCopy) onCopy(null); // this will clear shareCoord via handleCopyCoord(null)
  };

  return (
    <div
      style={{
        position: 'fixed',
        right: 26,
        bottom: 30,
        zIndex: 2100,
        background: '#23242a',
        color: '#fff',
        borderRadius: 14,
        boxShadow: '0 4px 14px #000b',
        padding: '10px 14px 11px 14px',
        border: '1.5px solid #3a3b46',
        minWidth: 220,
        maxWidth: 260,
        fontFamily:
          'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
        fontSize: 14,
        display: 'flex',
        flexDirection: 'column',
        gap: 6,
      }}
      onClick={(e) => e.stopPropagation()}
      role="dialog"
      aria-modal="true"
      aria-label="Share coordinates"
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          marginBottom: 2,
        }}
      >
        <div style={{ fontWeight: 700, fontSize: 15, flex: 1 }}>
          Map Coordinates
        </div>
        <button
          type="button"
          onClick={handleCloseClick}
          style={{
            background: '#444',
            color: '#fff',
            border: 'none',
            borderRadius: 999,
            width: 22,
            height: 22,
            fontSize: 14,
            fontWeight: 700,
            cursor: 'pointer',
            lineHeight: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 0,
          }}
        >
          ×
        </button>
      </div>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          fontFamily: 'monospace',
          fontSize: 14,
          color: '#ffe670',
        }}
      >
        <span>X: {x}</span>
        <span>Y: {y}</span>
      </div>

      <button
        type="button"
        onClick={handleCopyClick}
        style={{
          marginTop: 8,
          alignSelf: 'flex-start',
          background: copied ? '#3ac46a' : '#ffe670',
          color: copied ? '#062b11' : '#3d2900',
          borderRadius: 8,
          padding: '7px 18px',
          border: '1px solid #c4aa27',
          fontWeight: 700,
          fontSize: 15,
          cursor: 'pointer',
          boxShadow: '0 2px 8px #0008',
          transition: 'background 0.15s, transform 0.08s',
        }}
      >
        {copied ? 'Copied!' : 'Copy coordinate'}
      </button>
    </div>
  );
}
